module.exports = __webpack_public_path__ + "img/bigbluffcavern.6d288f30.png";